import { BackgroundContainerComponent } from "@/lib/background/container/component"
import { consumeLoading } from "@/lib/consume/loading"

export const BackgroundContainerConsumer = consumeLoading(
  BackgroundContainerComponent
)
